export class ReportePorCerealUtils {
  static parseDataCombinada (dataPorSilo, totales) {
    if (!dataPorSilo.filas || !totales.filas) {
      return []
    }
    const total = totales.filas[0]
    dataPorSilo.filas.push({
      silo: ``,
      sector: total.sector,
      linea: '',
      cereal: 'Total',
      cerealVariedad: '',
      metrosDeVacio: total.metrosDeVacioTotal,
      pesoNetoTotalBaseTrigo: total.pesoNetoTotalBaseTrigo,
      pesoNetoTotalBaseVigente: total.pesoNetoTotalBaseVigente,
      pesoNetoBaseVigente: total.pesoNetoBaseVigente,
      espacioNetoTotal: total.espacioNetoTotal,
      espacioTotalCamiones: total.espacioTotalCamiones
    })
    return dataPorSilo.filas
  }
}
